import { FC, useState } from "react";

interface Props {
  title: string;
  desc: string;
}

const charLimit = 200;

const ActionStepCard: FC<Props> = ({ title, desc }) => {
  const [showAll, setShowAll] = useState(false);
  return (
    <div
      className="flex ml-3 text-left p-8 flex-col border h-fit rounded-2xl w-full bg-[#F8F9FC] cursor-pointer"
      onClick={() => setShowAll((al) => !al)}
    >
      <h6 className="p-0 m-0 pb-4 font-semibold text-[20px] text-[#3E4784]">
        {title}
      </h6>
      <p className="p-0 m-0">
        {desc.length > charLimit && !showAll
          ? `${desc.slice(0, charLimit - 3)}...`
          : desc}
      </p>
      {desc.length > charLimit && (
        <div className="text-[#A3A7AF] hover:text-gray-500 cursor-pointer pt-4 w-full">
          {showAll ? "See less" : "See more..."}
        </div>
      )}
    </div>
  );
};

export default ActionStepCard;
